import React from "react";
import { UseFormRegisterReturn } from "react-hook-form/dist/types/form";
import { useFormContext } from "react-hook-form";
import * as C from "./styles";

interface Props<T = string> {
  disabled?: boolean;
  label?: string;
  formName?: T;
  containerStyle?: React.CSSProperties;
  onChangeState?: (e: { isChecked: boolean; label: string }) => any;
  initialState?: boolean;
}

export default function FormRadio<Type>({
  containerStyle,
  disabled,
  label,
  formName,
  onChangeState,
  initialState,
}: Props<keyof Type>) {
  const [radioState, setRadioState] = React.useState<
    "unselected" | "selected" | "disabled"
  >(initialState ? "selected" : "unselected");
  const [realRadioState, setRealRadioState] = React.useState<boolean>(false);
  const methods = useFormContext();

  React.useEffect(() => {
    if (disabled) setRadioState("disabled");
    if (radioState == "selected" && onChangeState) {
      onChangeState({ isChecked: true, label: label || "" });
    } else if (radioState == "unselected" && onChangeState) {
      onChangeState({ isChecked: false, label: label || "" });
    }
  }, [radioState]);

  React.useEffect(() => {
    if (disabled) setRadioState("disabled");
    if (!disabled) {
      setRadioState(initialState ? "selected" : "unselected");
      setRealRadioState(initialState ?? false);
    }
  }, [disabled]);

  React.useEffect(() => {
    let methodState = methods?.watch(formName as string);
    console.log(methodState)
    if(methodState == true){
      setRadioState("selected");
      setRealRadioState(true);
    }
    else if(methodState == false){
      setRadioState("unselected");
      setRealRadioState(false);
    }
  }, [methods?.watch((formName as string) ?? "")]);

  return (
    <C.MainContainer style={containerStyle} state={radioState}>
      <C.RealRadioButton
        type="checkbox"
        {...(formName && methods.register((formName as string) ?? "", {}))}
      />
      <C.RadioContainer
        state={radioState}
        onClick={() => {
          if (!disabled) {
            if (radioState == "selected") {
              setRadioState("unselected");
              setRealRadioState(false);
            } else {
              setRadioState("selected");
              setRealRadioState(true);
            }
          } else {
            setRadioState("disabled");
          }
          methods?.setValue((formName as string) ?? "", !realRadioState);
        }}
      >
        <C.RadioMark state={radioState} />
      </C.RadioContainer>
      <C.Label state={radioState}>{label}</C.Label>
    </C.MainContainer>
  );
}
